import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import React, { Component } from "react";
import Select from "react-select";
import { instance } from "Actions/AxiosInstance";
import { ValidateAction } from "Utils/Validation";
import { getEJ2CalenderDateFormat, convertDateForBackend } from "Utils";
import { DatePickerComponent } from "Component/Custom";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class company_incorporation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        subscriptionname: "",
        incorporationdate: "",
        subscriptiontypeid: null,
        statutorydetail: [],
      },
      reqFields: {},
      list: {
        subscriptiontypeid: {
          displayvalue: "",
          displayname: "",
        },
      },
      reqList: {},
      errors: {},
      subscriptionTypeList: [],
    };
  }

  componentDidMount() {
    this.GetSubscriptionType();
    const id = this.props.onboarding.configStatus;
    this.GetAllSubscription(id);
    this.GetForm();
  }

  GetSubscriptionType() {
    instance
      .get("superuser/getmastercode/SubscriptionType")
      .then((result) => {
        const subscriptionTypeList = [];
        subscriptionTypeList.push(
          { displayname: "Select Subscription Type", displayvalue: "" },
          ...result.data.result,
        );
        this.GetForm();

        this.setState({ subscriptionTypeList });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetAllSubscription(id) {
    instance
      .get(`account/allsubscription`)
      .then((result) => {
        const subscriptionsData = [
          ...result.data.result.Active,
          ...result.data.result.InActive,
        ];
        const currentsubscription = subscriptionsData.find(
          (data) => data.subscriptionid == id,
        );

        if (currentsubscription.issetupdone) {
          const employeeLink = `${window.location.origin}/dashboard`;
          setTimeout(() => {
            window.open(employeeLink, "_self");
          }, 100);
        } else {
          this.setState({
            currentsubscription,
            // stepcompleted: currentsubscription.stepcompleted,
            // logo: currentsubscription.logopath,
            // step: currentsubscription.stepcompleted,
            // dr: true,
          });
        }
      })
      .catch((error) => {
        // console.log('error: ', error);
      });
  }

  GetForm() {
    const URL = `account/incorporation/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}`;
    instance
      .get(URL)
      .then((result) => {
        const data = result.data.result[0];
        const fields = {
          subscriptionname: get(data, "subscriptionname", ""),
          incorporationdate: get(data, "incorporationdate", ""),
          subscriptiontypeid:
            get(data, "subscriptiontypeid", "") == null
              ? null
              : get(data, "subscriptiontypeid", ""),
          statutorydetail: get(data, "statutorydetail", []),
        };
        const subscriptiontypeid = this.state.subscriptionTypeList.find(
          (x) => x.displayvalue == data.subscriptiontypeid,
        );
        const { list } = this.state;
        list.subscriptiontypeid = subscriptiontypeid;
        const subid = this.state.subscriptionTypeList.find(
          (sub) => sub.displayvalue == data.subscriptiontypeid,
        );
        this.setState({ fields, list, subid });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    if (field == "subscriptiontypeid") {
      fields[field] = e.displayvalue;
      this.setState({ fields, subid: e });
      ValidateAction(this.state, field, type);
    } else if (field == "sendersignature") {
      fields[field] = e;
      this.setState({ fields });
      ValidateAction(this.state, field, type);
    } else {
      fields[field] = e.target.value;
      this.setState({ fields });
      ValidateAction(this.state, field, type);
    }
  }

  OnFieldChange2(field, type, index, option, e) {
    const fields = {
      ...this.state.fields,
      statutorydetail: this.state.fields.statutorydetail.map((x) => {
        if (x.statutoryid == option.statutoryid) {
          x.statutoryvalue = e.target.value;
        }
        return x;
      }),
    };
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  OnFieldChange3(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.value;
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  OnFormSubmit() {
    if (this.state.fields.subscriptionname == "") {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else if (this.state.fields.incorporationdate == "") {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      const data = {
        subscriptionname: this.state.fields.subscriptionname,
        incorporationdate: convertDateForBackend(
          this.state.fields.incorporationdate,
        ),
        subscriptiontypeid: this.state.fields.subscriptiontypeid,
        statutorydetail: this.state.fields.statutorydetail,
        stepcompleted: this.props.dashboard
          ? this.props.currentsubscription.stepcompleted
          : this.props.stepcompleted > this.props.step
          ? this.props.stepcompleted
          : this.props.step,
      };
      console.log("data", data);
      const URL = `account/incorporation/${get(
        this.props,
        "SubscriptionInfo.SubscriptionData.subscriptionid",
        "",
      )}`;
      instance
        .put(URL, data)
        .then((result) => {
          this.setState({
            ...result.data.result,
          });
          // if (this.props.dashboard) {
          //   this.props.enqueueSnackbar("Saved successfully", {
          //     variant: "success",
          //   });
          // }
          // if (!this.props.dashboard) {
          //   this.props.updateStep(5);
          //   this.props.enqueueSnackbar("Saved successfully", {
          //     variant: "success",
          //   });
          // }
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <p className="large-text-dark-secondary t-bold margin-bottom-40">
          Incorporation details
        </p>

        <Grid container>
          <Grid container spacing={3}>
            <Grid item md={4} sm={6}>
              <div>
                <p className="input-label">Company Legal Name</p>
                <TextField
                  className="margin-top-0 width100"
                  placeholder="Enter Company Name"
                  onChange={this.OnFieldChange.bind(
                    this,
                    "subscriptionname",
                    "text",
                  )}
                  value={this.state.fields.subscriptionname}
                  maxLength="50"
                  id="outlined-bare"
                  type="text"
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={4} sm={6}>
              <div>
                <p className="input-label">Incorporation Date (Optional)</p>
                <div>
                  <DatePickerComponent
                    format={getEJ2CalenderDateFormat()}
                    start="Decade"
                    // onClick={() => this.dateObj.show()}
                    // ref={(date)) => (this.dateObj = date)}
                    allowEdit={false}
                    border="1px solid #166ab3 !important"
                    change={this.OnFieldChange3.bind(
                      this,
                      "incorporationdate",
                      "text",
                    )}
                    value={this.state.fields.incorporationdate}
                  />
                </div>
              </div>
            </Grid>
            <Grid item md={4} sm={6}>
              <div>
                <p className="input-label">Company Type (Optional)</p>
                <Select
                  placeholder="Company type"
                  maxLength="256"
                  className="width100"
                  options={this.state.subscriptionTypeList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={(event) =>
                    this.OnFieldChange("subscriptiontypeid", "text", event)
                  }
                  value={get(this.state, "subid", "")}
                />
              </div>
            </Grid>
            {get(this.state, "fields.statutorydetail", [])
              .slice(0, get(this.state, "fields.statutorydetail", []).length)
              .map((option, index) => (
                <Grid key="key" item md={4} sm={6}>
                  <div>
                    <p className="input-label">
                      {option.statutoryname}
                      {"(Optional)"}
                    </p>
                    <TextField
                      className="margin-top-0 width100"
                      onChange={this.OnFieldChange2.bind(
                        this,
                        "statutoryname",
                        "text",
                        index,
                        option,
                      )}
                      value={option.statutoryvalue}
                      maxLength="50"
                      id="outlined-bare"
                      type="text"
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                </Grid>
              ))}
          </Grid>
        </Grid>

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div className="floatright" style={{ marginRight: 72 }}>
            <div>
              <Button
                color="primary"
                variant="contained"
                className="btn btn-primary-md-blue"
                onClick={this.OnFormSubmit.bind(this)}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="clearfloat"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  onboarding: state.Onboarding,
});

export default withRouter(
  connect(mapStateToProps, null)(withSnackbar(company_incorporation)),
);
